import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { ApiKeysResponse, ApiScopesResponse, CreateApiKeyRequest } from './api-keys.model';
import { PaginationParams } from '../general-store/general.model';

@Injectable({ providedIn: 'root' })
export class ApiKeysService {
  private readonly apiUrl = environment.apiUrl + '/api/api-keys/';

  private readonly http = inject(HttpClient);

  getAllApiKeys(params?: PaginationParams): Observable<ApiKeysResponse> {
    let httpParams = new HttpParams();

    if (params) {
      const page = params.first / params.rows + 1;
      httpParams = httpParams.set('page', page.toString());
      httpParams = httpParams.set('limit', params.rows.toString());

      if (params.sortBy) {
        httpParams = httpParams.set('sortBy', params.sortBy);
      }
      if (params.sortOrder) {
        httpParams = httpParams.set('sortOrder', params.sortOrder);
      }
      if (params.search) {
        httpParams = httpParams.set('search', params.search);
      }
      if (params.filters) {
        httpParams = httpParams.set('filters', params.filters);
      }
    }

    return this.http.get<ApiKeysResponse>(this.apiUrl, { params: httpParams });
  }

  createApiKey(payload: CreateApiKeyRequest): Observable<ApiKeysResponse> {
    return this.http.post<ApiKeysResponse>(this.apiUrl, payload);
  }

  deleteApiKey(id: number): Observable<ApiKeysResponse> {
    return this.http.delete<ApiKeysResponse>(this.apiUrl + id);
  }

  updateApiKey(id: number, payload: CreateApiKeyRequest): Observable<ApiKeysResponse> {
    return this.http.put<ApiKeysResponse>(this.apiUrl + id, payload);
  }

  getApiScopes(): Observable<ApiScopesResponse> {
    return this.http.get<ApiScopesResponse>(this.apiUrl + 'api-scopes');
  }
}
